module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "cont",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "cont"
    }
  }, [_c('b', [_vm._v("Contents")])])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    staticClass: "CFMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface",
      "id": "c_pre"
    }
  }, [_c('b', [_c('i', [_vm._v("Preface")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CCTF"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction",
      "id": "c_int"
    }
  }, [_c('b', [_vm._v("Introduction: What Is Radical Theology?")])])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter1",
      "id": "c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("1")]), _vm._v("      Tradition and Event: Radicalizing the Catholic Principle")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "id": "c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("2")]), _vm._v("      Proclaiming the Year of the Jubilee: Thoughts on a Spectral Life")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "id": "c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("3")]), _vm._v("      Derrida and the Trace of Religion")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "id": "c_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("4")]), _vm._v("      Augustine and Postmodernism")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "id": "c_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("5")]), _vm._v("      On Not Settling for an Abridged Edition of Postmodernism: Radical Hermeneutics as Radical Theology")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "id": "c_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("6")]), _vm._v("      Unprotected Religion: Radical Theology, Radical Atheism, and the Return of Anti-Religion")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "id": "c_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("7")]), _vm._v("      Forget Rationality—Is There Religious Truth?")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "id": "c_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("8")]), _vm._v("      Radical Theologians, Knights of Faith, and the Future of the Philosophy of Religion")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "id": "c_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("9")]), _vm._v("      Theology in Trumptime: The Insistence of America")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "id": "c_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('samp', {
    staticClass: "ccn"
  }, [_vm._v("10")]), _vm._v("    Hoping against Hope: The Possibility of the Impossible")])]), _vm._v(" "), _c('li', {
    staticClass: "CCT1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/like",
      "id": "c_lik",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Like a Devilish Knight of Faith: A Concluding Quasi-Theological Postscript")])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMHF"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "id": "c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "id": "c_not",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Notes")])])])]), _vm._v(" "), _c('li', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "id": "c_ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Index")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 78
// module chunks = 0